import { render, staticRenderFns } from "./LButtonGroup.vue?vue&type=template&id=63e5f22e"
import script from "./LButtonGroup.vue?vue&type=script&lang=js"
export * from "./LButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports